export const {
  DatetimeFormat,
  I18nInjectionKey,
  NumberFormat,
  Translation,
  VERSION,
  createI18n,
  useI18n,
  vTDirective
} = window.VueI18n;
